import React from 'react';

export interface IModel {
   id: string;
   lastUpdatedOn: string;
   createdOn: string;
}

export enum UserRole {
   ADMIN = 'ADMIN',
   INSURANCE_ADMIN = 'INSURANCE_ADMIN',
}

export enum Visibility {
   VISIBLE = 'VISIBLE',
   HIDDEN = 'HIDDEN',
}

export interface SideBarRouteOption {
   path: string;
   icon: React.ComponentType<any>;
   exact?: boolean;
   routes?: SideBarRouteOption[];
   name: string;
   altPaths?: string[];
   iconSize?: number;
   roleAcessible?: string[];
   hasSubRoutes?: boolean;
}

export interface ProfileProps {
   profileUrl?: string;
   email: string;
   companyName: string;
}
export interface ISidebarProps {
   isActive: boolean;
}

export interface SideBarRoute {
   manage: SideBarRouteOption[];
   options: SideBarRouteOption[];
}

export interface IInsurance {
   createdOn: string | null;
   lastUpdatedOn: string | null;
   createdBy: string | null;
   lastUpdatedBy: string | null;
   status: 'ACTIVE' | 'INACTIVE';
   hotlineNumber: string | null;
   id: string;
   name: string;
   code: string;
   members?: number;
   email: string;
}

export interface Role {
   roleId: string;
   roleName: string;
   createdAt?: string;
}

export interface IEligibilityCheckHistory {
   createdOn: string;
   healthFacility: string;
   insuranceName: string;
   url: string;
   message: string;
   responseJson: any;
   responseStatus: number;
}

export interface IResponse<T> {
   data: T;
   message: string;
   status: number;
}

export interface IAuditLog {
   id: string;
   auditType: string;
   operatorId: string;
   operatorNames: string;
   doneAt: string;
   remarks: string;
}

export interface IFile {
   createdAt: string;
   updatedAt: string;
   id: string;
   name: string;
   path: string;
   url: string;
   size: number;
   sizeType: 'B' | 'KB' | 'MB' | 'GB';
   type: string;
   status: 'SAVED' | string;
   visibility: Visibility;
}

export enum EReportStatus {
   COMPLETED = 'COMPLETED',
   FAILED = 'FAILED',
   PROCESSING = 'PROCESSING',
   PENDING = 'PENDING',
}

export enum EReportClass {
   ELIGIBILITY_LOGS = 'ELIGIBILITY_LOGS',
   APPROVALS = 'APPROVALS',
   BILLS = 'BILLS',
   MEDICAL_ITEMS = 'MEDICAL_ITEMS',
   TARIFFS = 'TARIFFS',
}

export interface IReport {
   reportName: string;
   jobId: number;
   file: IFile;
   rowCount: number;
   generatedBy: string;
   reportClass: EReportClass;
   reportStatus: EReportStatus;
   insuranceId: string | null;
   createdAt: string;
}
